/** Routes to scenes (docs/spec/07 §1): the game and the kit are the app's; every menu is the UI's. */

import { createKitScene } from '../editor';
import { createUiScene } from '../ui/scenes';
import type { Scene, SceneFactory } from '../ui/scene';
import type { GameDeps } from './game/gameScene';
import { GameScene } from './game/gameScene';

export function createFactory(game: GameDeps): SceneFactory {
  return (route, host): Scene => {
    if (route.to === 'play') return new GameScene(host, route.request, game);
    if (route.to === 'kit') return createKitScene(host, route.def);
    return createUiScene(route, host);
  };
}
